import { CellText } from "assets/js/Styles";
import CustomCheckbox from "components/customs/checkbox";
import { ADD_ACTION } from "constants/actions";
import React from "react";
import { Check } from "react-feather";
import styled from "styled-components";
import { getFormattedContactNumber } from "utility/helpers";

const CheckboxContainer = styled.div`
  width: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const AddEventColumns = ({ recipients, setRecipients, action }) => {
  return [
    {
      name: "",
      selector: (row) => row?.id,
      sortable: false,
      width: "60px",
      cell: ({ id }) => {
        return (
          <CheckboxContainer>
            <CustomCheckbox
              onChange={(evt) => {
                const { checked } = evt.target;

                if (checked) {
                  setRecipients({
                    ...recipients,
                    congInvitees: [...recipients.congInvitees, id],
                  });
                } else {
                  const newItems = recipients.congInvitees.filter(
                    (recipient) => recipient !== id
                  );

                  setRecipients({
                    ...recipients,
                    congInvitees: newItems,
                    excludedCongs: [...recipients.excludedCongs, id],
                  });
                }
              }}
              disabled={action !== ADD_ACTION}
              icon={
                <Check
                  className="vx-icon"
                  size={16}
                />
              }
              checked={recipients.congInvitees.includes(id)}
            />
          </CheckboxContainer>
        );
      },
    },
    {
      name: "Congressman",
      selector: (row) => row?.name,
      grow: 2,
      sortable: true,
      cell: ({ name }) => <CellText>{name}</CellText>,
    },
    {
      name: "Area",
      selector: (row) => row?.area,
      sortable: true,
      cell: ({ area }) => <CellText>{area}</CellText>,
    },
    {
      name: "Contact Number",
      selector: (row) => row?.contact,
      cell: ({ contact }) => (
        <CellText>{getFormattedContactNumber(contact)}</CellText>
      ),
    },
    {
      name: "COS",
      selector: (row) => row?.cos,
      grow: 2,
      sortable: true,
      cell: ({ cos }) => <CellText>{cos}</CellText>,
    },
    {
      name: "COS Contact Number",
      selector: (row) => row?.cosContact,
      cell: ({ cosContact }) => (
        <CellText>{getFormattedContactNumber(cosContact)}</CellText>
      ),
    },
  ];
};

export default AddEventColumns;
